export default __webpack_public_path__ + "static/media/Slide_LifeBridge_Register-04.e5b92e55.png";